// extracted by mini-css-extract-plugin
export default {"container":"declaration_container__opS0j","declare":"declaration_declare__IQMnU"};